import { render, staticRenderFns } from "./ToolPageTheory.vue?vue&type=template&id=e5d72d68&scoped=true&"
import script from "./ToolPageTheory.vue?vue&type=script&lang=ts&"
export * from "./ToolPageTheory.vue?vue&type=script&lang=ts&"
import style0 from "./ToolPageTheory.vue?vue&type=style&index=0&id=e5d72d68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d72d68",
  null
  
)

export default component.exports